import { render, staticRenderFns } from "./AlertTitleComponent.vue?vue&type=template&id=91fd896c"
import script from "./AlertTitleComponent.vue?vue&type=script&lang=js"
export * from "./AlertTitleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports